<template>
<div>
  <el-button style="width:100%;" type="primary" size="small" @click="open">마이그레이션</el-button>
  <w-sliding-popup ref="slidingPopup" title="마이그레이션" top="50px" width="800px" @close="close">
    <div slot="content">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div  class="vertical-center-box">
          <el-radio-group class="ordinary" v-model="migrationType" size="mini">
            <el-radio-button label="HOST">호스트</el-radio-button>
            <el-radio-button label="STORAGE">스토리지</el-radio-button>
          </el-radio-group>
        </div>
        <div class="vertical-center-box">
          <el-button class="mr-r4" type="secondary" @click="loadData">새로고침</el-button>
          <el-button class="mr-r4" type="secondary" @click="onMigrationButtonClick">마이그레이션</el-button>
          <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper v-show="migrationType === 'HOST'" :data="hostMigrationData" :columns="hostMigrationColumn" :column-default="columnDefault" ref="hostMigrationTable" highlight-current-row
      @row-click="selectMigrationData('HOST', ...arguments)" :pagination="true" :show-search-tool="migrationType === 'HOST' && showSearchTool" row-class-name="c-pointer" :show-custom-header="true">
        <template slot-scope="scope" slot="selected-slot">
          <span v-if="scope.row['selectFlag']"><i class="far fa-check" style="color: #63a53c"></i></span>
          <span v-else>-</span>
        </template>
        <template slot-scope="scope" slot="status-slot">
          <span v-if="scope.row['VHO_RUNNINGSTATUS/ALIVE'] === '1'">켜짐</span>
          <span v-else>꺼짐</span>
        </template>
        <template slot-scope="scope" slot="cpu-slot">
          <w-rsc-perf-event-progress-bar v-if="getStringtoNumber(scope.row['VHO_CPU/USERATE']) >= 0" :perfRecords="scope.row" perfKey="VHO_CPU/USERATE" />
          <span v-else>{{ EMPTY_TEXT }}</span>
        </template>
        <template slot-scope="scope" slot="memory-slot">
          <w-rsc-perf-event-progress-bar v-if="getStringtoNumber(scope.row['VHO_MEM/USERATE']) >= 0" :perfRecords="scope.row" perfKey="VHO_MEM/USERATE" />
          <span v-else>{{ EMPTY_TEXT }}</span>
        </template>
      </el-table-wrapper>
      <el-table-wrapper v-show="migrationType === 'STORAGE'" :data="storageMigrationData" :columns="storageMigrationColumn" :column-default="columnDefault" ref="storageMigrationTable" highlight-current-row
      @row-click="selectMigrationData('STORAGE', ...arguments)" :pagination="true" :show-search-tool="migrationType === 'STORAGE' && showSearchTool" row-class-name="c-pointer" :show-custom-header="true">
        <template slot-scope="scope" slot="selected-slot">
          <span v-if="scope.row['selectFlag']"><i class="far fa-check" style="color: #63a53c"></i></span>
          <span v-else>-</span>
        </template>
        <template slot-scope="scope" slot="disk-slot">
          <w-rsc-perf-event-progress-bar v-if="getStringtoNumber(scope.row['VDS_STORAGE/USERATE']) >= 0" :perfRecords="scope.row" perfKey="VDS_STORAGE/USERATE" />
          <span v-else>{{ EMPTY_TEXT }}</span>
        </template>
      </el-table-wrapper>
    </div>
  </w-sliding-popup>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import findIndex from 'lodash/findIndex';
import commonApi from '@/api/virtual/performance/common';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { columnDefault } from '@/constants/table';
import WRscPerfEventProgressBar from '@/components/progressbar/RscPerfEventProgressBar';

const OBJTYPEID_ATTR = {
  VHO: [{ attrTypeId: 'VHO_COMMON', attrId: 'VM_COUNT' }],
  VDS: [{ attrTypeId: 'VDS_COMMON', attrId: 'VM_COUNT' }],
};

export default {
  name: 'WVirtualMigrationPopup',
  components: {
    WRscPerfEventProgressBar,
  },
  props: {
    objInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      columnDefault,
      migrationType: 'HOST',
      showSearchTool: false,
      hostMigrationData: [], // 호스트
      hostMigrationColumn: [
        { label: '선택', width: 70, prop: 'currentHost', scopedSlot: 'selected-slot' },
        { label: '호스트명', prop: 'objName', sortable: true, searchable: true },
        { label: '상태', width: 70, prop: 'VHO_RUNNINGSTATUS/ALIVE', sortable: true, scopedSlot: 'status-slot' },
        { label: 'VM수', width: 70, prop: 'vmCount', sortable: true },
        { label: 'CPU 사용률 (%)', align: 'center', scopedSlot: 'cpu-slot' },
        { label: '메모리 사용률 (%)', scopedSlot: 'memory-slot', align: 'center' },
      ],
      storageMigrationData: [], // 스토리지
      storageMigrationColumn: [
        { label: '선택', width: 70, prop: 'currentHost', scopedSlot: 'selected-slot' },
        { label: '스토리지명', prop: 'objName', sortable: true, searchable: true },
        { label: 'VM수', width: 70, prop: 'vmCount', sortable: true },
        { label: '전체 용량(Byte)', prop: 'VDS_STORAGE/TOTAL_CAPACITY', formatter: this.convertValue },
        { label: '사용량(Byte)', prop: 'VDS_STORAGE/USED_CAPACITY', formatter: this.convertValue },
        { label: '사용률(%)', scopedSlot: 'disk-slot', align: 'center' },
        { label: '가용량(Byte)', prop: 'VDS_STORAGE/AVSIZE', formatter: this.convertValue },
      ],
      hostSelectedData: {},
      storageSelectedData: {},
      hostOriginData: {},
      storageOriginData: {},
    };
  },
  watch: {
    migrationType: {
      handler() {
        this.loadData();
      },
    },
  },
  methods: {
    /**
     * 호스트 및 데이터스토어 리스트 조회
     * @author kimjy
     * @return {[type]} [description]
     */
    loadData() {
      const params = {
        objtypeId: this.migrationType === 'HOST' ? 'VHO' : 'VDS',
        objId: this.objInfo.obj.objId,
        hypervisorType: this.objInfo.hypervisorType,
        managetypeId: 'VMS',
        attrInfoParams: this.migrationType === 'HOST' ? OBJTYPEID_ATTR.VHO : OBJTYPEID_ATTR.VDS,
      };
      commonApi.getVirtualMigrationList(params).then((res) => {
        if (res.data.success) {
          this[`${this.migrationType.toLowerCase()}MigrationData`] = res.data.data;
          const index = findIndex(res.data.data, { selectFlag: true });
          this[`${this.migrationType.toLowerCase()}OriginData`] = res.data.data[index];
        }
      });
    },
    selectMigrationData(migrationType, row) {
      this[`${migrationType.toLowerCase()}SelectedData`] = row;
    },
    getStringtoNumber(value) {
      return Number(value);
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    convertValue(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return convertValuByUnit(value, 'MB');
    },
    /**
     * 마이그레이션 수행
     * @author kimjy
     * @return {[type]} [description]
     */
    onMigrationButtonClick() {
      const migrationType = this.migrationType.toLowerCase();
      const originData = this[`${migrationType}OriginData`];
      const selectedData = this[`${migrationType}SelectedData`];

      if (isEmpty(selectedData) || originData.objId === selectedData.objId) {
        this.$message(msgUtil.getCustomResultMsgData('다른 대상을 선택해주십시오.', false));
        return;
      }

      const params = {
        hypervisorType: this.objInfo.hypervisorType,
        objId: this.objInfo.obj.objId,
        migrationType: this.migrationType,
        vmsObjKey: selectedData.vmsObjKey,
      };

      commonApi.executeVmMigration(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getCustomResultMsgData('마이그레이션을 수행하였습니다.', true));
        }
      });
    },
    open() {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadData();
      });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/VirtualMigrationPopup.vue